import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { IconButton } from "../IconButton";
import { Button } from "../Button";
import { ArrowLeftOutlineIcon, ArrowRightOutlineIcon } from "../Icons";
import { paginationStyles as classes } from './styles';
function PaginationItem(props) {
    const { color = 'blue', disabled, isSelected, label, page, type, onPageChange, ref, ...componentProps } = props;
    switch (type) {
        case 'dots':
            return _jsx("span", { css: classes.dots(color), children: "..." });
        case 'next':
        case 'previous':
            return (_jsx(IconButton, { ref: ref, variant: 'ghost', color: color, size: 'small', onClick: () => {
                    onPageChange?.(page);
                }, disabled: disabled, ...componentProps, component: disabled ? 'button' : componentProps.component, href: disabled ? undefined : componentProps.href, to: disabled ? undefined : componentProps.to, label: label, children: type === 'previous' ? _jsx(ArrowLeftOutlineIcon, {}) : _jsx(ArrowRightOutlineIcon, {}) }));
        default:
            return (_jsx(Button, { ref: ref, variant: 'ghost', color: color, size: 'small', onClick: () => {
                    onPageChange?.(page);
                }, isSelected: isSelected, "aria-current": isSelected ? 'page' : undefined, ...componentProps, "aria-label": label, children: page }));
    }
}
/**
 * A component that renders a pagination item, which can be a page number, previous/next button, or dots.
 */
export { PaginationItem };
